import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import app from './modules/app'
import game from './modules/game'

const state = {
	
}

const store = new Vuex.Store({
	state,
	modules: {
		game,
		app
	},
	strict: process.env.NODE_ENV !== 'production'
})

export default store


// WEBPACK FOOTER //
// ./src/store/store.js